/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Hierarchy,
} from '../models/index';
import {
    HierarchyFromJSON,
    HierarchyToJSON,
} from '../models/index';

export interface GetOrganisationChildsRequest {
    organisationId: number;
}

export interface GetOrganisationHierarchyRequest {
    organisationId: number;
}

export interface GetOrganisationTopOrgaRequest {
    organisationId: number;
}

export interface GetPersonTopOrgaRequest {
    personId: number;
}

export interface GetProjectChildsRequest {
    projectId: number;
}

export interface GetProjectHierarchyRequest {
    projectId: number;
}

export interface GetProjectTopOrgaRequest {
    projectId: number;
}

export interface GetWorkTopOrgaRequest {
    workId: number;
}

/**
 * 
 */
export class HierarchyApi extends runtime.BaseAPI {

    /**
     * Creates request options for getOrganisationChilds without sending the request
     */
    async getOrganisationChildsRequestOpts(requestParameters: GetOrganisationChildsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getOrganisationChilds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/organisation/{organisationId}/childs`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOrganisationChildsRaw(requestParameters: GetOrganisationChildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Hierarchy>>> {
        const requestOptions = await this.getOrganisationChildsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HierarchyFromJSON));
    }

    /**
     */
    async getOrganisationChilds(requestParameters: GetOrganisationChildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Hierarchy>> {
        const response = await this.getOrganisationChildsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganisationHierarchy without sending the request
     */
    async getOrganisationHierarchyRequestOpts(requestParameters: GetOrganisationHierarchyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getOrganisationHierarchy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/organisation/{organisationId}`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOrganisationHierarchyRaw(requestParameters: GetOrganisationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Hierarchy>>> {
        const requestOptions = await this.getOrganisationHierarchyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HierarchyFromJSON));
    }

    /**
     */
    async getOrganisationHierarchy(requestParameters: GetOrganisationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Hierarchy>> {
        const response = await this.getOrganisationHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganisationTopOrga without sending the request
     */
    async getOrganisationTopOrgaRequestOpts(requestParameters: GetOrganisationTopOrgaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organisationId'] == null) {
            throw new runtime.RequiredError(
                'organisationId',
                'Required parameter "organisationId" was null or undefined when calling getOrganisationTopOrga().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/topOrga/organisation/{organisationId}`;
        urlPath = urlPath.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters['organisationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOrganisationTopOrgaRaw(requestParameters: GetOrganisationTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getOrganisationTopOrgaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getOrganisationTopOrga(requestParameters: GetOrganisationTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getOrganisationTopOrgaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPersonTopOrga without sending the request
     */
    async getPersonTopOrgaRequestOpts(requestParameters: GetPersonTopOrgaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPersonTopOrga().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/topOrga/person/{personId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonTopOrgaRaw(requestParameters: GetPersonTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getPersonTopOrgaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPersonTopOrga(requestParameters: GetPersonTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getPersonTopOrgaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectChilds without sending the request
     */
    async getProjectChildsRequestOpts(requestParameters: GetProjectChildsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectChilds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/project/{projectId}/childs`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProjectChildsRaw(requestParameters: GetProjectChildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Hierarchy>>> {
        const requestOptions = await this.getProjectChildsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HierarchyFromJSON));
    }

    /**
     */
    async getProjectChilds(requestParameters: GetProjectChildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Hierarchy>> {
        const response = await this.getProjectChildsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectHierarchy without sending the request
     */
    async getProjectHierarchyRequestOpts(requestParameters: GetProjectHierarchyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectHierarchy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/project/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProjectHierarchyRaw(requestParameters: GetProjectHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Hierarchy>>> {
        const requestOptions = await this.getProjectHierarchyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HierarchyFromJSON));
    }

    /**
     */
    async getProjectHierarchy(requestParameters: GetProjectHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Hierarchy>> {
        const response = await this.getProjectHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectTopOrga without sending the request
     */
    async getProjectTopOrgaRequestOpts(requestParameters: GetProjectTopOrgaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectTopOrga().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/topOrga/project/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProjectTopOrgaRaw(requestParameters: GetProjectTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getProjectTopOrgaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getProjectTopOrga(requestParameters: GetProjectTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getProjectTopOrgaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorkTopOrga without sending the request
     */
    async getWorkTopOrgaRequestOpts(requestParameters: GetWorkTopOrgaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling getWorkTopOrga().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/hierarchy/topOrga/work/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorkTopOrgaRaw(requestParameters: GetWorkTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getWorkTopOrgaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getWorkTopOrga(requestParameters: GetWorkTopOrgaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getWorkTopOrgaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
